import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  MenuItem,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  useMediaQuery,
    Table,
      TableBody,
      TableCell,
      TableContainer,
      TableHead,
      TableRow,
       InputAdornment,
         DialogTitle,
    DialogActions,
    Checkbox,
    Popover,
      CircularProgress,
      Autocomplete,
      Chip,
      alpha,
} from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import {
  useCreateModifierGrpMutation,
  useGetAllCategoryNameQuery,
  useGetAllMainModifierCategoryQuery,
  useGetLastProductIdQuery,
  useGetPrinterQuery,
  useGetProductBrandQuery,
  useGetProductTagQuery,
  useGetSubCategoryByArrayQuery,
  useGetSubCategoryByCategoryIdQuery,
  useGetModifierQuery,
  useGetCategoryQuery,
    useGetProductQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {
  ICategory,
  ILastProductId,
  IPrinter,
  IProductBrand,
  IProductPopUP,
  IModifierGrpPopUp,
  IProductTag,
  IModifierPopUp,
  ProductInfo,
  ModifierInfo
} from "../../../Api/Interface/api.interface";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Switch, { SwitchProps } from "@mui/material/Switch";
import AddIcon from "@mui/icons-material/Add";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import CustomSwitch from "../../../Components/Switch/CustomSwitch";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import { HexColorPicker } from "react-colorful";
import Barcode from "react-barcode";
import AppsIcon from "@mui/icons-material/Apps";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import NewProductBrand from "../../ProductBrand/Edit/index";
import NewPrinter from "../../Printer/Edit/index";
import NewProductTag from "../../ProductTags/Edit/index";
import { uploadImage } from "../../../Components/UploadFile/upload";
// import ProductLoopingPopUp from "../Components/productLoopingPopUp";
import { styled, useTheme } from "@mui/material/styles";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AlertPopUp from "../../../Components/AlertPopUp/AlertPopup";
import { CiSearch } from "react-icons/ci";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface IProductPopup {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  data?: IModifierGrpPopUp;
}

const steps = ["Basic Details", "Looping Table", "Done"];

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(28px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 30, // Increased thumb size
    height: 30, // Increased thumb size
  },
  "& .MuiSwitch-track": {
    borderRadius: 34 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#757575" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`, // Using SVG path for check
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`, // Using SVG path for minus
      right: 12,
    },
  },
}));

const isPrinterArray = (data: any): data is IPrinter[] => {
  return (
    Array.isArray(data) &&
    data.every(
      (item) =>
        "id" in item && "printerName" in item && "printerDescription" in item
    )
  );
};

// Image imports
const img1 = require("../../../Images/img1.jpg");
const img2 = require("../../../Images/img2.jpg");
const img3 = require("../../../Images/img3.jpg");

const ProductPopUP = ({
  openModel = false,
  handleCloseDialog,
  data,
}: IProductPopup) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open] = React.useState(openModel);
  const [activeStep, setActiveStep] = useState(0);
  const [showCategorySelection, setShowCategorySelection] = useState(false);
  const [newModifier, { isLoading }] = useCreateModifierGrpMutation();
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const { showErrorMessage, showMessage } = useNotifier();
  const [overwriteChoice, setOverwriteChoice] = useState<Record<number, 'yes' | 'no'>>({});
  const [overwritePrices, setOverwritePrices] = useState<Record<number, number>>({});
  const handleClose = () => {
    handleCloseDialog(false);
  };
  const gridHeight = isMobile ? "30px" : "400px";
   const [currentSearchQueryProduct, setCurrentSearchQueryProduct] =useState<string>("");



  // const { data: categoryNameData } = useGetAllCategoryNameQuery();
  
  // const { data: productCategoryData, isLoading: productCategoryLoading } =
  //   useGetSubCategoryByCategoryIdQuery({
  //     categoryId: "currentCategoryId",
  //   });
  // const { data: productBrandData, isLoading: ProductBrandLoading } =
  //   useGetProductBrandQuery({
  //     searchText: "",
  //     isActive: true,
  //   });
  // const { data: productTagData, isLoading: ProductTagLoading } =
  //   useGetProductTagQuery({
  //     searchText: "",
  //     isActive: true,
  //   });
  // const { data: printerData, isLoading: PrinterLoading } = useGetPrinterQuery({
  //   searchText: "",
  // });

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);

  const [openProductCategory, setOpenProductCategory] = useState(false);
  const [openProductBrand, setOpenProductBrand] = useState(false);
  const [openProductTag, setOpenProductTag] = useState(false);
  const [openPrinter, setOpenPrinter] = useState(false);
  const [selectedColor, setSelectedColor] = useState<string>("#FFFFFF");
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorPickerRef = useRef<HTMLDivElement>(null);
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [modifiers, setModifiers] = React.useState<ModifierInfo[]>([]);
  const initializedRef = useRef(false);
  // const { data: newLastProductIdData, isLoading: lastProductIdIsLoading } =
  //   useGetLastProductIdQuery();
  const [showBarcode, setShowBarcode] = useState(false);

  const [openLoopingCategoryDialog, setOpenLoopingCategoryDialog] =
    useState(false);

  const [openGallery, setOpenGallery] = useState(false);
  const [selectedImage, setSelectedImage] = useState<File | undefined>(
    undefined
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
const selectedModifierIds = modifiers.map((m) => m.modifier_id);

  // const lastProductId = useMemo(() => {
  //   return (newLastProductIdData?.data as ILastProductId)?.lastInsertedId ?? 0;
  // }, [newLastProductIdData?.data]);

  // const productBrandList = useMemo(() => {
  //   return productBrandData?.data as IProductBrand[];
  // }, [productBrandData?.data]);
  

  // const productTagList = useMemo(() => {
  //   return productTagData?.data as IProductTag[];
  // }, [productTagData?.data]);

  // const printerList: IPrinter[] = useMemo(() => {
  //   if (!printerData || !isPrinterArray(printerData.data)) {
  //     return [];
  //   }
  //   return printerData.data;
  // }, [printerData]);

  const { data: subCategoryData, refetch: refetchSubCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
    });

  const { data: subCategory2Data, refetch: refetchS2bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
        : [],
    });
    const [searchText, setSearchText] = useState("");
    const [selectedRows, setSelectedRows] = useState<Record<number, boolean>>({});
    
    // For dropdown menu
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    
    
    // For Price Dialog
    const [openPriceDialog, setOpenPriceDialog] = useState(false);
    // Live product search (replaces category-gated list)
    const [productSearch, setProductSearch] = useState("");
    const [duplicateWarning, setDuplicateWarning] = useState<string>("");
    const [recentlyAddedId, setRecentlyAddedId] = useState<number | null>(null);
    const [recentlyPricedIds, setRecentlyPricedIds] = useState<Set<number>>(new Set());
    const [priceValue, setPriceValue] = useState("");
    
      const { data: categoryData, isLoading: categoryLoading } =
        useGetCategoryQuery();

    // const { data: modifierData } = useGetModifierQuery({
    //    productBrandId:  null,
    //   productCategoryId:  null,
    //   productTagIds: null,
    //   modifierViewOnline:null,
    //   createdDateEnd:  null,
    //   createdDateStart:null,
    //   searchText: null,
    //   createdDate: null,
    //   id:  "",
    //   });
    

  const { data: subCategory3Data, refetch: refetchS3bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [
            Number(selectedCategoryId),
            Number(selectedSubCategoryId),
            Number(selectedSubToSubCategoryId),
          ]
        : [],
    });

  // const [productDetails, setProductDetails] = useState({
  //   id: "",
  //   productDetailsIsLooping: false,
  //   productsDetailsLoopingConstant: "",
  //   productName: "",
  // });

   const productCategoryId = selectedSubToSubToSubCategoryId
    ? Number(selectedSubToSubToSubCategoryId)
    : selectedSubToSubCategoryId
    ? Number(selectedSubToSubCategoryId)
    : selectedSubCategoryId
    ? Number(selectedSubCategoryId)
    : selectedCategoryId
    ? Number(selectedCategoryId)
    : String("");


  const {
      data: productData,
      isLoading: productIsLoading,
      refetch: productRefetch,
    } = useGetProductQuery({
      productBrandId: null,
     productCategoryId: String(productCategoryId), 
      productTagIds: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      searchText: currentSearchQueryProduct,
      createdDate: null,
      id: null,
    });

   const productList: IProductPopUP[] = Array.isArray(productData?.data)
      ? (productData?.data as IProductPopUP[])
      : [];

 
    //   const modifierList = useMemo(() => {
    //   return modifierData?.data as IModifierPopUp[];
    // }, [modifierData?.data]);

  // const categoryGetAllList = useMemo(() => {
  //   return categoryNameData?.data as ICategory[];
  // }, [categoryNameData?.data]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);


  // const subCategoryList = useMemo(() => {
  //   return subCategoryData?.data as ICategory[];
  // }, [subCategoryData?.data]);

  // const subToSubCategoryList = useMemo(() => {
  //   return subCategory2Data?.data as ICategory[];
  // }, [subCategory2Data?.data]);

  // const subToSubToSubCategoryList = useMemo(() => {
  //   return subCategory3Data?.data as ICategory[];
  // }, [subCategory3Data?.data]);

  
useEffect(() => {
  if (initializedRef.current) return;
  if (!data?.modifiers || productList.length === 0) return;

  const parsed =
    typeof data.modifiers === 'string'
      ? JSON.parse(data.modifiers)
      : data.modifiers;

  const formatted = parsed.map((mod: any) => {
    const info = productList.find((p) => Number(p.id) === Number(mod.product_id));
    return {
      product_id: mod.product_id,
      price: mod.price,
      pos: mod.pos ?? false,
      online: mod.online ?? false,
      productName: info?.productName ?? "",
    };
  });

  formik.setFieldValue("modifiers", formatted);
  if (data?.categoryId) {
    setSelectedCategoryId(Number(data.categoryId));
  }
  initializedRef.current = true;
}, [data, productList]);

  // const coursingMap = useMemo(() => {
  //   const map = new Map();
  //   categoryGetAllList?.forEach((category) => {
  //     map.set(category.id, category.categoryName);
  //   });
  //   return map;
  // }, [categoryGetAllList]);

  const formik = useFormik({
    initialValues: {
      id: data?.id,
      categoryId: data?.categoryId,
      modifierGroupName: data?.modifierGroupName,
      minimum: data?.minimum,
      maximum: data?.maximum,
      modifiers: typeof data?.modifiers === "string" ? JSON.parse(data.modifiers) : data?.modifiers || [],
      isActive: data?.isActive ? Boolean(data?.isActive) : false,
    
    },

    onSubmit: async (values) => {
      try {

 const modifierDetails = (values.modifiers || []).map((mod: any) => ({
  product_id: mod.product_id,
  price: Number(mod.price) || 0,
  pos: !!mod.pos,
  online: !!mod.online,
}));

      
    let forceUpdate = false;

      if (values?.id && data?.modifiers) {
        const originalMods = typeof data.modifiers === "string" ? JSON.parse(data.modifiers) : data.modifiers;

       const oldIds = originalMods.map((m: any) => Number(m.product_id));
const newIds = modifierDetails.map((m: any) => Number(m.product_id));

const structureChanged =
  oldIds.length !== newIds.length || oldIds.some((id: any) => !newIds.includes(id));


        // --- If structure changed (add/remove), force update without confirmation ---
        if (structureChanged) {
          forceUpdate = true;
        } else {
          // --- Only check value changes (price/pos/online) ---
          for (let old of originalMods) {
            const updated = modifierDetails.find((m: any) => Number(m.product_id) === Number(old.product_id));
            if (updated) {
              if (
                Number(old.price) !== Number(updated.price) ||
                Boolean(old.pos) !== Boolean(updated.pos) ||
                Boolean(old.online) !== Boolean(updated.online)
              ) {
                forceUpdate = window.confirm(
                  "You changed modifier values. Do you want to update all products that use this modifier group?"
                );
                break;
              }
            }
          }
        }
      }

    
        const temData = {
          id: values?.id,
          categoryId: selectedCategoryId,
          modifierGroupName: values.modifierGroupName,
          minimum: values.minimum,
          maximum: values.maximum,
          modifiers: modifierDetails, 
          isActive: values.isActive,
             force_update: forceUpdate,
        };

        if (!data) {
          delete temData.id;
        }

        const addProductResponse = await newModifier(temData).unwrap();
        if (!addProductResponse.status) {
          setAlertMessage(addProductResponse.message);
          setDeleteAlert(true);
        } else {
          showMessage(addProductResponse.message);
            handleClose();
          // if (addProductResponse.data.productDetailsIsLooping) {
          //   setActiveStep(1);
          // } else {
          //   setActiveStep(2);
          // }
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const canSave = useMemo(() => {
    if (!formik.values.modifierGroupName?.trim()) return false;
    const mods = formik.values.modifiers;
    if (!Array.isArray(mods) || mods.length === 0) return false;
    return true;
  }, [formik.values.modifierGroupName, formik.values.modifiers]);

  const hasSelectedRows = useMemo(
    () => Object.values(selectedRows).some(Boolean),
    [selectedRows]
  );

  const resizeImage = (
    file: File,
    maxWidth: number,
    maxHeight: number
  ): Promise<File> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target?.result as string;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;

          // Calculate the new dimensions while maintaining aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            if (blob) {
              const resizedFile = new File([blob], file.name, {
                type: file.type,
              });
              resolve(resizedFile);
            } else {
              reject(new Error("Canvas is empty"));
            }
          }, file.type);
        };

        img.onerror = (error) => reject(error);
      };
    });
  };

const applyBulkToggle = (field: "pos" | "online") => {
  const current = formik.values.modifiers || [];
  const updated = current.map((item: any) =>
    selectedRows[Number(item.product_id)]
      ? { ...item, [field]: !item[field] }
      : item
  );
  formik.setFieldValue("modifiers", updated);
};

const applyPriceUpdate = () => {
  const parsed = parseFloat(priceValue);
  if (isNaN(parsed) || parsed < 0) return;
  const current = formik.values.modifiers || [];
  const touched = new Set<number>();
  const updated = current.map((item: any) => {
    if (selectedRows[Number(item.product_id)]) {
      touched.add(Number(item.product_id));
      return { ...item, price: parsed };
    }
    return item;
  });
  formik.setFieldValue("modifiers", updated);
  setRecentlyPricedIds(touched);
  setTimeout(() => setRecentlyPricedIds(new Set()), 1500);
  setOpenPriceDialog(false);
  setPriceValue("");
};

 const handleModifierChange = (e: React.ChangeEvent<{ value: unknown }>) => {
   const value = e.target.value;
   const selectedIds =
     typeof value === "string"
       ? value.split(',').map(Number)
       : (value as number[]);
 
   const newModifiers = selectedIds.map((id) => {
     const existing = modifiers.find((m) => m.modifier_id === id);
     return existing ?? {
       modifier_id: id,
       overwrite: false,
       overwrite_price: null,
     };
   });
 
   setModifiers(newModifiers);
 };

const handleAddModifier = (product: IProductPopUP) => {
  const current = formik.values.modifiers || [];
  const alreadyAdded = current.some((m: any) => Number(m.product_id) === Number(product.id));
  if (alreadyAdded) {
    setDuplicateWarning(`"${product.productName}" is already added to this modifier group`);
    setTimeout(() => setDuplicateWarning(""), 3500);
    return;
  }
  formik.setFieldValue("modifiers", [
    ...current,
    {
      product_id: product.id,
      price: null,
      pos: false,
      online: false,
      productName: product.productName || "",
    },
  ]);
  setRecentlyAddedId(Number(product.id));
  setProductSearch("");
  setDuplicateWarning("");
  setTimeout(() => setRecentlyAddedId((v) => (v === Number(product.id) ? null : v)), 1500);
  // Scroll the new row into view next paint
  setTimeout(() => {
    document.getElementById(`modifier-row-${product.id}`)?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, 50);
};


  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      const maxSize = 2048 * 1024;

      if (!validTypes.includes(file.type)) {
        showErrorMessage("The file must be an image (jpeg, png, jpg, gif).");
        setSelectedImage(undefined);
      } else if (file.size > maxSize) {
        showErrorMessage("The file must be smaller than 2 MB.");
        setSelectedImage(undefined);
      } else {
        try {
          const resizedImage = await resizeImage(file, 500, 500);
          setSelectedImage(resizedImage);
        } catch (error) {
          showErrorMessage("Failed to resize the image.");
          setSelectedImage(undefined);
        }
      }
    } else {
      setSelectedImage(undefined);
    }
  };

  const handleGallerySelection = (selectedImage: string) => {
    fetch(selectedImage)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], "image.jpg", { type: blob.type });
        setSelectedImage(file);
      });
    setOpenGallery(false);
  };

  const openGalleryDialog = () => {
    setOpenGallery(true);
  };

  const closeGalleryDialog = () => {
    setOpenGallery(false);
  };

  const galleryImages = [img2, img3, img2, img3, img2, img3];

  
  const handleMainCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const categoryId = event.target.value as number;
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
    formik.setFieldValue("mainCatId", categoryId);

    const selectedCategory = categoryList.find(
      (category) => category.id == categoryId
    );

    if (selectedCategory) {
      formik.setFieldValue(
        "productDetailsIsLooping",
        selectedCategory.categoryIsLooping
      );
      formik.setFieldValue(
        "productsDetailsLoopingConstant",
        selectedCategory.categoryLoopingConstant
      );
    }
  };

  // const handleSubCategoryChange = (
  //   event: React.ChangeEvent<{ value: unknown }>
  // ) => {
  //   const subCategoryId = event.target.value as number;
  //   setSelectedSubCategoryId(subCategoryId);
  //   setSelectedSubToSubCategoryId(null);
  //   setSelectedSubToSubToSubCategoryId(null);

  //   const selectedCategory = subCategoryList.find(
  //     (category) => category.id == subCategoryId
  //   );

  //   if (selectedCategory) {
  //     formik.setFieldValue(
  //       "productDetailsIsLooping",
  //       selectedCategory.categoryIsLooping
  //     );
  //     formik.setFieldValue(
  //       "productsDetailsLoopingConstant",
  //       selectedCategory.categoryLoopingConstant
  //     );
  //   }
  // };

  // const handleSubToSubCategoryChange = (
  //   event: React.ChangeEvent<{ value: unknown }>
  // ) => {
  //   const selectedSubToSubCategoryId = event.target.value as number;
  //   setSelectedSubToSubCategoryId(selectedSubToSubCategoryId);
  //   setSelectedSubToSubToSubCategoryId(null);

  //   const selectedCategory = subToSubCategoryList.find(
  //     (category) => category.id == selectedSubToSubCategoryId
  //   );

  //   if (selectedCategory) {
  //     formik.setFieldValue(
  //       "productDetailsIsLooping",
  //       selectedCategory.categoryIsLooping
  //     );
  //     formik.setFieldValue(
  //       "productsDetailsLoopingConstant",
  //       selectedCategory.categoryLoopingConstant
  //     );
  //   }
  // };

  // const handleSubToSubToSubCategoryChange = (
  //   event: React.ChangeEvent<{ value: unknown }>
  // ) => {
  //   const selectedSubToSubToSubCategoryId = event.target.value as number;
  //   setSelectedSubToSubToSubCategoryId(selectedSubToSubToSubCategoryId);

  //   const selectedCategory = subToSubToSubCategoryList.find(
  //     (category) => category.id == selectedSubToSubToSubCategoryId
  //   );

  //   if (selectedCategory) {
  //     formik.setFieldValue(
  //       "productDetailsIsLooping",
  //       selectedCategory.categoryIsLooping
  //     );
  //     formik.setFieldValue(
  //       "productsDetailsLoopingConstant",
  //       selectedCategory.categoryLoopingConstant
  //     );
  //   }
  // };

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };


  // const handleShowCategorySelection = () => {
  //   setShowCategorySelection(true);
  // };

  

  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          maxWidth: "1700px",
        },
      }}
    >
      <Grid className={classes.Dialog}>
       <Grid container spacing={3}>
              <Grid item lg={4} md={4} sm={12} xs={12}>
                <Card className={classes.stepperCard}  sx={{ mb: 2 }}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
      
      <Grid container spacing={3} p={"5px"}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                      <TextField
                         label="Modifier Group Name"
                                    // placeholder="Enter Modifier Group Name"
                                    size="small"
                                    {...formik.getFieldProps("modifierGroupName")}
                                    className={classes.textField}
                                    InputProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                  </Grid>
                                  </Grid>

                                          {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                                                          <Grid container alignItems="center">
                                                  <TextField
                                                   label="Minimum"
                                                                // placeholder="Enter Minimum"
                                                                size="small"
                                                                {...formik.getFieldProps("minimum")}
                                                                type="number"
                                                                className={classes.textField}
                                                                InputProps={{
                                                                  sx: {
                                                                    fontSize: 14,
                                                                  },
                                                                }}
                                                                InputLabelProps={{
                                                                  sx: {
                                                                    fontSize: 14,
                                                                  },
                                                                }}
                                                              />
                                                              </Grid>
                                                              </Grid>
                                  
                                                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                                          <Grid container alignItems="center">
                                                  <TextField
                                                                label="Maximum"
                                                                // placeholder="Enter Maximum"
                                                                type="number"
                                                                size="small"
                                                                {...formik.getFieldProps("maximum")}
                                                                className={classes.textField}
                                                                InputProps={{
                                                                  sx: {
                                                                    fontSize: 14,
                                                                  },
                                                                }}
                                                                InputLabelProps={{
                                                                  sx: {
                                                                    fontSize: 14,
                                                                  },
                                                                }}
                                                              />
                                                              </Grid>
                                                              </Grid> */}
      
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
      
                                      <TextField
                                         label="Category"
                                                         select
                                                         fullWidth
                                                         size="small"
                                                         className={classes.textField}
                                                         value={selectedCategoryId ?? ""}
                                                         onChange={handleMainCategoryChange}
                                                         InputLabelProps={{ shrink: true }}
                                                       >
                                                         <MenuItem
                                                           value=""
                                                          
                                                           style={{ color: "gray" }}
                                                         >
                                                           Select Category
                                                         </MenuItem>
                                                         {categoryList &&
                                                           categoryList
                                                           .filter((category) => !category.parent_ids || category.parent_ids.length === 0) 
                                                           .map((category) => (
                                                             <MenuItem
                                                               key={category.id}
                                                               value={category.id}
                                                             >
                                                               {category.categoryName}
                                                             </MenuItem>
                                                           ))}
                                                       </TextField>
                                                       </Grid></Grid>
      
      
      
        <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder="Search product.."
                      sx={{ width: "100%" }}
                      size="small"
                    />
                  </Grid>
        </Grid>
        
      
                </Grid>
      
      
                    </Grid>
                  </Grid>
                </Card>
      
      
                 <Card className={classes.stepperCard} sx={{height: 280, overflowY: 'auto'}}>
                <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={5}
                            sx={{ borderBottom: 2, padding: 2 }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              pt={2}
                              alignContent={"center"}
                            >
                              <Typography className={classes.cardTitle}>
                             Product List
                              </Typography>
                            </Grid>
                          </Grid>
      
                          <Grid container spacing={3} p={"5px"}>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Box sx={{ padding: 2 }}>
                  {(() => {
                    const currentMods = formik.values.modifiers || [];
                    const addedIds = new Set(currentMods.map((m: any) => Number(m.product_id)));
                    const eligible = productList.filter((p) => p.isModifier);
                    const q = productSearch.trim().toLowerCase();
                    const filtered = q
                      ? eligible.filter((p) =>
                          (p.productName || "").toLowerCase().includes(q) ||
                          String((p as any).productBarcode || "").toLowerCase().includes(q) ||
                          String((p as any).productManualBarcode || "").toLowerCase().includes(q)
                        ).slice(0, 50)
                      : [];

                    return (
                      <Box>
                        <Autocomplete
                          fullWidth size="small"
                          options={filtered}
                          inputValue={productSearch}
                          onInputChange={(_, v, reason) => { if (reason === "input") setProductSearch(v); }}
                          getOptionLabel={(o) => o.productName || ""}
                          filterOptions={(opts) => opts}
                          onChange={(_, picked) => { if (picked) handleAddModifier(picked); }}
                          isOptionEqualToValue={(o, v) => Number(o.id) === Number(v.id)}
                          openOnFocus
                          noOptionsText={
                            q.length === 0 ? "Start typing to search products" : "No matching products found"
                          }
                          renderOption={(props, option) => {
                            const already = addedIds.has(Number(option.id));
                            return (
                              <li {...props} key={option.id} style={{
                                opacity: already ? 0.55 : 1,
                                fontSize: 13,
                                display: "flex",
                                justifyContent: "space-between",
                                gap: 8,
                              }}>
                                <span style={{ textTransform: "capitalize" }}>{option.productName}</span>
                                {already ? (
                                  <Chip size="small" label="Added" sx={{ height: 18, fontSize: 10, fontWeight: 700, bgcolor: "#E5E7EB", color: "#6B7280" }} />
                                ) : (
                                  <Chip size="small" label="+ Add" sx={{ height: 18, fontSize: 10, fontWeight: 700, bgcolor: "#DBEAFE", color: "#1D4ED8" }} />
                                )}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search products by name or barcode…"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <CiSearch style={{ fontSize: 16, color: "#94a3b8" }} />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          )}
                        />
                        {duplicateWarning && (
                          <Typography sx={{ mt: 1, fontSize: 11.5, fontWeight: 600, color: "#D97706", bgcolor: "#FEF3C7", px: 1.25, py: 0.75, borderRadius: 1 }}>
                            {duplicateWarning}
                          </Typography>
                        )}
                        <Typography sx={{ mt: 1.5, fontSize: 10, color: "#94a3b8" }}>
                          Tip: results filter live as you type — name, barcode, and manual barcode are all searched.
                        </Typography>
                      </Box>
                    );
                  })()}
                </Box>
              </Grid>

                          </Grid>
                        </Card>
                      </Grid>
      
                    
              
              <Grid item lg={8} md={8} sm={12} xs={12}>
               
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card} sx={{ height:500, overflowY: 'auto' }}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
                            <Typography className={classes.cardTitle}>
                             Modifier
                            </Typography>
                          </Grid>
      
        <Grid
                item
                lg={8}
                md={8}
                sm={8}
                xs={8}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                 
                  <Grid item>
                    <Button
                      variant="contained"
                      className={classes.addButton}
                      endIcon={<ArrowDropDownIcon />}
                      disabled={!hasSelectedRows}
                      onClick={(e) => setAnchorEl(e.currentTarget)}
                    >
                      Edit
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
      
                        </Grid>
      
      
      
         {selectedCategoryId && (
                
        <Grid>
           
           <TableContainer>
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}><strong>Product Name</strong></TableCell>
                <TableCell className={classes.tablheader}><strong>Price</strong></TableCell>
                  <TableCell className={classes.tablheader}><strong>Online</strong></TableCell>
                    <TableCell className={classes.tablheader}><strong>POS</strong></TableCell>
                {/* <TableCell className={classes.tablheader}><strong>Overwrite?</strong></TableCell>
                <TableCell className={classes.tablheader}><strong>Overwrite Price</strong></TableCell> */}
                <TableCell className={classes.tablheader}><strong>Action</strong></TableCell>
                  <TableCell className={classes.tablheader}>
                      <Checkbox
        checked={
          (formik.values.modifiers?.length ?? 0) > 0 &&
          (formik.values.modifiers || []).every((item: any) => selectedRows[Number(item.product_id)])
        }
        indeterminate={
          (formik.values.modifiers || []).some((item: any) => selectedRows[Number(item.product_id)]) &&
          !(formik.values.modifiers || []).every((item: any) => selectedRows[Number(item.product_id)])
        }
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const newSelected: Record<number, boolean> = {};
          if (e.target.checked) {
            (formik.values.modifiers || []).forEach((item: any) => {
              newSelected[Number(item.product_id)] = true;
            });
          }
          setSelectedRows(newSelected);
        }}
      />
      
      
      
                                </TableCell>
              </TableRow>
            </TableHead>
          <TableBody>
        {(formik.values.modifiers || []).map((mod: any, index: number) => {
          const pid = Number(mod.product_id);
          const isNew = recentlyAddedId === pid;
          const isPriced = recentlyPricedIds.has(pid);
          return (
            <TableRow
              key={mod.product_id}
              id={`modifier-row-${mod.product_id}`}
              sx={{
                transition: "background-color 0.6s ease",
                bgcolor: isNew ? alpha("#1D4ED8", 0.08) : isPriced ? alpha("#059669", 0.08) : "transparent",
              }}
            >
              <TableCell sx={{ textTransform: "capitalize", fontWeight: isNew ? 700 : 400 }}>{mod.productName}</TableCell>
          <TableCell>
        <TextField
          size="small"
          placeholder="0.00"
          value={mod.price === null || mod.price === undefined ? "" : String(mod.price)}
          onChange={(e) => {
            const v = e.target.value;
            if (v !== "" && !/^\d*\.?\d{0,2}$/.test(v)) return;
            const updated = [...(formik.values.modifiers || [])];
            updated[index] = {
              ...updated[index],
              price: v === "" ? null : Number(v),
            };
            formik.setFieldValue("modifiers", updated);
          }}
          InputProps={{ startAdornment: <InputAdornment position="start" sx={{ mr: 0.25 }}>$</InputAdornment> }}
          inputProps={{ inputMode: "decimal" }}
          sx={{
            width: 110,
            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": { WebkitAppearance: "none", margin: 0 },
            "& input[type=number]": { MozAppearance: "textfield" as const },
          }}
        />
      </TableCell>
      
             <TableCell>
        <IOSSwitch
          checked={mod.online ?? false}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const updated = [...(formik.values.modifiers || [])];
            updated[index] = {
              ...updated[index],
              online: event.target.checked,
            };
            formik.setFieldValue("modifiers", updated);
          }}
        />
      </TableCell>

      {/* POS SWITCH */}
      <TableCell>
        <IOSSwitch
          checked={mod.pos ?? false}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const updated = [...(formik.values.modifiers || [])];
            updated[index] = {
              ...updated[index],
              pos: event.target.checked,
            };
            formik.setFieldValue("modifiers", updated);
          }}
        />
      </TableCell>
      
            
              <TableCell>
                 <IconButton
          size="small"
          color="error"
          onClick={() => {
            const updated = (formik.values.modifiers || []).filter(
              (item: any) => item.product_id !== mod.product_id
            );
            formik.setFieldValue("modifiers", updated);
          }}
            sx={{
            backgroundColor: '#f8d7da',
            borderRadius: '50%',
            padding: '4px',
            '&:hover': {
              backgroundColor: '#f1b0b7',
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
              </TableCell>
      
                <TableCell className={classes.tablCell}>
                          <Checkbox
        checked={selectedRows[Number(mod.product_id)] || false}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setSelectedRows({
            ...selectedRows,
            [Number(mod.product_id)]: e.target.checked,
          });
        }}
      />
      
      
      
      
                                    </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
      
          </Table>
          </TableContainer>
        
        </Grid>
           )}
      
      
                      </Card>
                    </Grid>
      
                 
                  </Grid>
             
              </Grid>
      
      
      
      
      
        <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                        <Card className={classes.card}>
                          <Grid container spacing={3} p={"24px"}>
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              sx={{ display: "flex", justifyContent: "flex-end" }}
                            >
                              <Button
                                variant="outlined"
                                startIcon={<CloseIcon />}
                                className={classes.addButton}
                                onClick={handleClose}
                              >
                                Cancel
                              </Button>
                              <Box m={0.5}></Box>
      
                              <Button
                                variant="contained"
                                startIcon={<SaveAltIcon />}
                                className={classes.addButton}
                                onClick={() => formik.handleSubmit()}
                                disabled={!canSave || isLoading}
                              >
                                Save
                              </Button>
                            </Grid>
                          </Grid>
                </Card>
                
              </Grid>
      
            </Grid>
      
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setOpenPriceDialog(true);
          }}
        >
          Price
        </MenuItem>
      
        <MenuItem
          onClick={() => {
            applyBulkToggle("pos");
            setAnchorEl(null);
          }}
        >
          POS
        </MenuItem>
      
        <MenuItem
          onClick={() => {
            applyBulkToggle("online");
            setAnchorEl(null);
          }}
        >
          Online
        </MenuItem>
      </Popover>
      
      <Dialog
        open={openPriceDialog}
        onClose={() => { setOpenPriceDialog(false); setPriceValue(""); }}
        PaperProps={{ sx: { borderRadius: 3, minWidth: 460, p: 0.5 } }}
      >
        <DialogTitle sx={{ fontWeight: 800, fontSize: 18, color: "#0f172a", pb: 0.5 }}>
          Update Modifier Price
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          {(() => {
            const mods = formik.values.modifiers || [];
            const targets = mods.filter((m: any) => selectedRows[Number(m.product_id)]);
            const parsed = parseFloat(priceValue);
            const hasValid = !isNaN(parsed) && parsed >= 0;
            const fmt = (n: any) => (n === null || n === undefined || n === "" ? "—" : `$${Number(n).toFixed(2)}`);

            return (
              <Box>
                <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: "#F9FAFB", border: "1px solid #E5E7EB", mb: 2 }}>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#6B7280", mb: 0.5, textTransform: "uppercase", letterSpacing: 0.4 }}>
                    {targets.length === 0 ? "No products selected" : targets.length === 1 ? "Product" : `${targets.length} products selected`}
                  </Typography>
                  {targets.length === 1 ? (
                    <>
                      <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#111827", textTransform: "capitalize" }}>
                        {targets[0].productName}
                      </Typography>
                      <Typography sx={{ fontSize: 12, color: "#6B7280", mt: 0.25 }}>
                        Current price: <span style={{ fontWeight: 700, color: "#374151" }}>{fmt(targets[0].price)}</span>
                      </Typography>
                    </>
                  ) : targets.length > 1 ? (
                    <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
                      Setting the same price for {targets.length} products: {targets.slice(0, 3).map((t: any) => t.productName).join(", ")}{targets.length > 3 ? ` +${targets.length - 3} more` : ""}
                    </Typography>
                  ) : (
                    <Typography sx={{ fontSize: 12, color: "#9CA3AF" }}>Select rows in the table first.</Typography>
                  )}
                </Box>

                <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#374151", mb: 0.75 }}>New Price</Typography>
                <TextField
                  fullWidth autoFocus
                  placeholder="0.00"
                  value={priceValue}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (v === "" || /^\d*\.?\d{0,2}$/.test(v)) setPriceValue(v);
                  }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                  inputProps={{ inputMode: "decimal" }}
                  sx={{
                    "& .MuiOutlinedInput-root": { fontSize: 16, fontWeight: 700, borderRadius: 2 },
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": { WebkitAppearance: "none", margin: 0 },
                    "& input[type=number]": { MozAppearance: "textfield" as const },
                  }}
                />

                {hasValid && targets.length > 0 && (
                  <Box sx={{ mt: 2, p: 1.25, borderRadius: 2, bgcolor: "#ECFDF5", border: "1px solid #A7F3D0" }}>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#065F46", textTransform: "uppercase", letterSpacing: 0.4 }}>Preview</Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#065F46", mt: 0.25 }}>
                      {targets.length === 1
                        ? <>New price for {targets[0].productName}: <span style={{ fontSize: 16 }}>${parsed.toFixed(2)}</span></>
                        : <>All {targets.length} selected products will be set to <span style={{ fontSize: 16 }}>${parsed.toFixed(2)}</span></>}
                    </Typography>
                  </Box>
                )}
              </Box>
            );
          })()}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2.25, gap: 1 }}>
          <Button
            onClick={() => { setOpenPriceDialog(false); setPriceValue(""); }}
            sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, color: "#64748b" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained" disableElevation
            onClick={applyPriceUpdate}
            disabled={(() => {
              const parsed = parseFloat(priceValue);
              const targets = (formik.values.modifiers || []).filter((m: any) => selectedRows[Number(m.product_id)]);
              return isNaN(parsed) || parsed < 0 || targets.length === 0;
            })()}
            sx={{
              borderRadius: 2, textTransform: "none", fontWeight: 700, px: 2.5,
              background: "linear-gradient(135deg, #1E40AF 0%, #1D4ED8 100%)",
              "&:hover": { background: "linear-gradient(135deg, #1E3A8A 0%, #1E40AF 100%)" },
            }}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      </Grid>
    </Dialog>
  );
};

export default ProductPopUP;
